import { deserialize } from "./deserialize";
import { serialize } from "./serialize";

export class LocalStorage {
    constructor(public key: string) {}

    setItem(item: unknown): void {
        localStorage.setItem(this.key, serialize(item) ?? "");
    }

    getItem<TItem>(): TItem | null {
        const item = localStorage.getItem(this.key);
        if (item === null) {
            return null;
        }
        return deserialize<TItem>(item);
    }

    removeItem(): void {
        localStorage.removeItem(this.key);
    }
}
